import axios from "axios";
import { ENV } from "../config";
import keycloak from "../keycloak";
const API_BASE_URL = ENV.REACT_APP_REST_API; // update base URL

// GET with query params
// apiService({ url: "/products", method: "GET", params: { page: 1 } });

// // POST with data
// apiService({ url: "/login", method: "POST", data: { email, password } });

// // PUT
// apiService({ url: "/user/123", method: "PUT", data: { name: "Updated" } });

// // DELETE
// apiService({ url: "/user/123", method: "DELETE" });

export const apiService = async ({
  url,
  method = "GET",
  data = null,
  params = {},
  headers = {},
  send_auth = false,
}) => {
  try {
    // Validate required parameters
    if (!url) {
      throw new Error("URL is required");
    }
    let headerObj = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    // Add custom headers if provided
    if (method === "POST" || method === "PUT" || send_auth) {
      headerObj["authorization"] = `Bearer ${localStorage.getItem(
        "authorization"
      )}`;
      headerObj["x-refresh-token"] = localStorage.getItem("refreshToken");
    }

    // Make the API request
    const response = await axios({
      url: `${API_BASE_URL}/${url}`,
      method,
      data,
      params,
      headers: headerObj,
      // Add timeout to prevent hanging requests
      timeout: 30000, // 30 seconds
    });

    // Check for successful status codes (200, 201)
    if (response.status === 200 || response.status === 201) {
      return response.data;
    } else {
      // Handle non-2xx status codes
      throw {
        status: response.status,
        data: response.data,
        message: `Request failed with status code ${response.status}`,
      };
    }
  } catch (error) {
    // Handle different types of errors
    let errorDetails = {
      message: "Unknown Error",
      status: null,
      data: null,
    };

    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      errorDetails = {
        message: error.response.data?.message || error.message,
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
      };
    } else if (error.request) {
      // The request was made but no response was received
      errorDetails = {
        message: "No response received from server",
        status: null,
        data: null,
        originalError: error.message,
      };
    } else if (error instanceof Error) {
      // Something happened in setting up the request that triggered an Error
      errorDetails = {
        message: error.message,
        status: null,
        data: null,
      };
    }
    // 🔴 Handle token expiration
    if (
      errorDetails.message
        ?.toLowerCase()
        .includes("Token expired. Please log in again.")
    ) {
      keycloak.logout();
    }

    console.error("API Error:", {
      url,
      method,
      error: errorDetails,
    });

    throw errorDetails;
  }
};
